/**
 * 1天对应的秒数
 */
export const DAY_OF_SECONDS = 24 * 60 * 60

export const SECOND_OF_MS = 1000

export const MINUTE_OF_MS = 60 * SECOND_OF_MS

export const HOUR_OF_MS = 60 * MINUTE_OF_MS

export const DAY_OF_MS = 24 * HOUR_OF_MS

export const WEEK_OF_MS = 7 * DAY_OF_MS
